import { Button, Table } from 'antd';
import * as find from 'lodash/find';
import * as get from 'lodash/get';
import * as uniq from 'lodash/uniq';
import moment from 'moment';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import UserApi from '../../functions/api/user/UserApi';
import UserGroupApi from '../../functions/api/user/UserGroupApi';
import MyUtil from '../../functions/MyUtil';
import TableUtils from '../../functions/TableUtils';
import ButtonFormatter from './ButtonFormatter';

class ListUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listUser: [],
      listPartner: [],
      userGroup: [],
      redirectAdd: false,
      widthWindow: window.innerWidth,
    };
  }

  async componentDidMount() {
    const listUser = await UserApi.getUserByRole('2,3');
    const partner = uniq(listUser.map((user) => user.user_part_id)).join();
    const listPartner = await PartnerApi.getPartnerInList(partner);
    const userGroup = await UserGroupApi.getAllUserGroup();

    this.setState({ listUser, listPartner, userGroup });
  }

  partnerFormatter = (cell, row) => {
    const { listPartner } = this.state;
    const partner = find(listPartner, { part_id: cell });
    return (
      <span>
        {partner ? `${partner.part_id} - ${partner.part_name}` : 'CX Staff'}
      </span>
    );
  };

  roleFormatter = (cell) => {
    let userType = 'Khách hàng';
    if (cell === 3) userType = 'Đối tác';
    if (cell === 2) userType = 'CX - User';

    return <span>{userType}</span>;
  };

  lastLoginFormatter = (cell) => {
    return cell ? (
      <span>{`${moment(cell).format('DD/MM/YYYY HH:mm')}`}</span>
    ) : (
      ''
    );
  };

  userGroupFormatter = (cell) => {
    const { userGroup } = this.state;
    const group = find(userGroup, { user_group_id: cell });
    return get(group, 'user_group_name', '');
  };

  activeFormatter = (cell, row) => {
    return (
      <ButtonFormatter
        cell={cell}
        row={row}
        onChangeList={this.handleChangeList}
        list={this.state.listUser}
      />
    );
  };

  handleInsertButtonClick = () => {
    this.setState({ redirectAdd: true });
  };

  handleChangeList = (list) => {
    this.setState({ listUser: list });
  };

  render() {
    const { listUser } = this.state;
    const canAdd = MyUtil.hasPermission(this.props.match_parent.url, 'add');

    if (this.state.redirectAdd) {
      return <Redirect push to={`${this.props.match_parent.url}/add`} />;
    }

    const columnUsers = [
      {
        title: 'User ID',
        dataIndex: 'user_acc_id',
        key: 'user_acc_id',
        fixed: 'left',
      },
      {
        title: 'Đối tác',
        dataIndex: 'user_part_id',
        key: 'user_part_id',
        fixed: 'left',
        render: this.partnerFormatter,
      },
      {
        title: 'Loại người dùng',
        dataIndex: 'user_role_id',
        key: 'user_role_id',
        fixed: 'left',
        render: this.roleFormatter,
      },
      {
        title: 'Tên người dùng',
        dataIndex: 'user_acc_name',
        key: 'user_acc_name',
      },
      {
        title: 'Full name',
        dataIndex: 'user_acc_full_name',
        key: 'user_acc_full_name',
        ...TableUtils.getColumnSearchProps('user_acc_full_name'),
      },
      {
        title: 'Email',
        dataIndex: 'user_acc_emai',
        key: 'user_acc_emai',
        ...TableUtils.getColumnSearchProps('user_acc_emai'),
      },
      {
        title: 'Mobile',
        dataIndex: 'user_acc_phon',
        key: 'user_acc_phon',
      },
      {
        title: 'User Group',
        dataIndex: 'user_group_id',
        key: 'user_group_id',
        render: this.userGroupFormatter,
      },
      {
        title: ' Last Login',
        dataIndex: 'user_acc_last_logn',
        key: 'user_acc_last_logn',
        render: this.lastLoginFormatter,
      },
      {
        title: 'Chỉnh sửa',
        render: this.activeFormatter,
        fixed: 'right',
      },
    ];

    return (
      <div className="content">
        {canAdd && (
          <Button
            onClick={this.handleInsertButtonClick}
            type="primary"
            size="large"
          >
            Thêm
          </Button>
        )}
        <Table
          rowKey="user_acc_id"
          size="small"
          columns={columnUsers}
          dataSource={listUser}
          scroll={{ x: 'max-content' }}
        />
      </div>
    );
  }
}

export default ListUser;
